import type { SalesforceExportResult } from './types';

/** The one-line summary + tone for a finished cross-tenant Salesforce push. */
export function salesforceResultLine(result: SalesforceExportResult): { type: 'success' | 'warning'; message: string } {
  const heldBack = result.incomplete?.length ?? 0;
  const parts = [`${result.synced} pushed`, `${result.skipped} skipped`, `${result.failed.length} failed`];
  if (heldBack > 0) parts.push(`${heldBack} held back by lead rules`);
  return {
    type: result.failed.length > 0 || heldBack > 0 ? 'warning' : 'success',
    message: parts.join(' · '),
  };
}
